import React from 'react';
import { volumes } from '../data/content';
export function WhatsIncluded() {
  return <section id="included" className="w-full bg-slate-100 px-5 py-12 sm:py-16" data-id="element-195" data-mp="bvd0pmx0ccig">
      <div className="mx-auto max-w-[720px]" data-id="element-196" data-mp="3u9m6s0apwp6w">
        <h2 className="text-center text-[1.6rem] font-extrabold uppercase leading-[0.95] tracking-tight text-slate-950 sm:text-[2rem]" data-id="element-197" data-mp="3uanlqfuutvtw">
          What’s Included
        </h2>

        <ol className="mt-7 space-y-3" data-id="element-198" data-mp="puw7aba67fsn">
          {volumes.map(volume => <li key={volume.label} className="rounded-lg border border-slate-200 bg-white p-5" style={{
          borderLeft: `5px solid ${volume.color}`
        }} data-id="element-199" data-mp="uuig88iyu9vn">
              <p className="text-[0.75rem] font-black uppercase tracking-[0.18em]" style={{
            color: volume.color
          }} data-id="element-200" data-mp="ltkclrcfw4dl">
                {volume.label}
              </p>
              <h3 className="mt-1 text-[1rem] font-extrabold uppercase leading-tight tracking-tight text-slate-950 sm:text-[1.1rem]" data-id="element-201" data-mp="36kkuu32oevwv">
                {volume.title}
              </h3>
              <p className="mt-1 text-[0.95rem] leading-snug text-slate-800" data-id="element-202" data-mp="1rim1s4luanff">
                {volume.subtitle}
              </p>
              <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-203" data-mp="26gwhg4h66a6t">
                {volume.highlights.map(item => <li key={item} className="rounded-md bg-slate-100 px-2.5 py-1 text-[0.85rem] font-semibold text-slate-950" data-id="element-204" data-mp="21fz2e0rghw9j">
                    {item}
                  </li>)}
              </ul>
              <p className="mt-3 text-[0.8rem] font-extrabold uppercase tracking-tight text-slate-950" data-id="element-205" data-mp="2p6w1gcy5kz3d">
                {volume.footnote}
              </p>
            </li>)}
        </ol>
      </div>
    </section>;
}